<div [formGroup]="formGroup">
  <button *ngIf="isCleanable" type="button" class="button" (click)="reset()">{{ "components.address-completion.reset" | translate }}</button>
  <div *ngIf="!isSwissOnly" class="row">
    <mat-form-field class="col-12" appearance="fill">
      <mat-label>
        {{ "components.address-completion.country" | translate }}
      </mat-label>
      <mat-select formControlName="country" [required]="isMandatory">
        <mat-option *ngFor="let country of countries" [value]="country.alpha2">
          {{ country.name }}
        </mat-option>
      </mat-select>
      <mat-error
        *ngIf="formGroup.get('country')?.hasError('required')"
        translate
      >
        forms.errors.field-required
      </mat-error>
      <mat-error
        *ngIf="formGroup.get('country')?.errors?.maxlength as maxlengthError" 
        translate
      > 
        <span translate [translateParams]="{ maxLength: maxlengthError.requiredLength, currentLength: maxlengthError.actualLength }">
          forms.errors.max-length
        </span>
      </mat-error>
    </mat-form-field>
  </div>
  <div class="row row-block">
    <mat-form-field class="col-md-4 col-12" appearance="fill">
      <mat-label>
        {{ "components.address-completion.post-code" | translate }}
      </mat-label>
      <input
        autocomplete="off"
        matInput
        formControlName="postCode"
        [matAutocomplete]="autoPostCode"
        [required]="isMandatory"
      />
      <mat-autocomplete #autoPostCode="matAutocomplete">
        <mat-option
          *ngFor="let postCode of address.postCodes | async"
          [value]="postCode"
        >
          {{ postCode }}
        </mat-option>
      </mat-autocomplete>
      <mat-error
        *ngIf="formGroup.get('postCode')?.hasError('required')"
        translate
      >
        forms.errors.field-required
      </mat-error>
      <mat-error
        *ngIf="formGroup.get('postCode')?.errors?.maxlength as maxlengthError" 
        translate
      > 
        <span translate [translateParams]="{ maxLength: maxlengthError.requiredLength, currentLength: maxlengthError.actualLength }">
          forms.errors.max-length
        </span>
      </mat-error>
    </mat-form-field>
    <mat-form-field class="col-md-8 col-12" appearance="fill">
      <mat-label>
        {{ "components.address-completion.locality" | translate }}
      </mat-label>
      <input
        autocomplete="off"
        matInput
        formControlName="locality"
        [matAutocomplete]="autoLocality"
        [required]="isMandatory"
      />
      <mat-autocomplete #autoLocality="matAutocomplete">
        <mat-option
          *ngFor="let locality of address.localities | async"
          [value]="locality"
        >
          {{ locality }}
        </mat-option>
      </mat-autocomplete>
      <mat-error
        *ngIf="formGroup.get('locality')?.hasError('required')"
        translate
      >
        forms.errors.field-required
      </mat-error>
      <mat-error
        *ngIf="formGroup.get('locality')?.errors?.maxlength as maxlengthError" 
        translate
      > 
        <span translate [translateParams]="{ maxLength: maxlengthError.requiredLength, currentLength: maxlengthError.actualLength }">
          forms.errors.max-length
        </span>
      </mat-error>
    </mat-form-field>
  </div>
  <div class="row">
    <mat-form-field class="col-lg-10 col-md-8 col-12" appearance="fill">
      <mat-label>
        {{ "components.address-completion.street" | translate }}
      </mat-label>
      <input
        autocomplete="off"
        matInput
        formControlName="street"
        [matAutocomplete]="autoStreet"
        [required]="isMandatory"
      />
      <mat-autocomplete #autoStreet="matAutocomplete">
        <mat-option
          *ngFor="let street of address.streets | async"
          [value]="street"
        >
          {{ street }}
        </mat-option>
      </mat-autocomplete>
      <mat-error
        *ngIf="formGroup.get('street')?.hasError('required')"
        translate
      >
        forms.errors.field-required
      </mat-error>
      <mat-error
        *ngIf="formGroup.get('street')?.errors?.maxlength as maxlengthError" 
        translate
      > 
        <span translate [translateParams]="{ maxLength: maxlengthError.requiredLength, currentLength: maxlengthError.actualLength }">
          forms.errors.max-length
        </span>
      </mat-error>
    </mat-form-field>
    <mat-form-field class="col-lg-2 col-md-4 col-12" appearance="fill">
      <mat-label>
        {{ "components.address-completion.street-number" | translate }}
      </mat-label>
      <input
        autocomplete="off"
        matInput
        formControlName="streetNumber"
        [matAutocomplete]="autoStreetNumber"
        [required]="isMandatory"
      />
      <mat-autocomplete #autoStreetNumber="matAutocomplete">
        <mat-option
          *ngFor="let streetNumber of address.streetNumbers | async"
          [value]="streetNumber"
        >
          {{ streetNumber }}
        </mat-option>
      </mat-autocomplete>
      <mat-error
        *ngIf="formGroup.get('streetNumber')?.hasError('required')"
        translate
      >
        forms.errors.field-required
      </mat-error>
      <mat-error
        *ngIf="formGroup.get('streetNumber')?.errors?.maxlength as maxlengthError" 
        translate
      > 
        <span translate [translateParams]="{ maxLength: maxlengthError.requiredLength, currentLength: maxlengthError.actualLength }">
          forms.errors.max-length
        </span>
      </mat-error>
    </mat-form-field>
  </div>
  <mat-error
    class="address-invalid"
    *ngIf="formGroup.hasError('addressInvalid')"
    translate
  >
    components.address-completion.address-invalid
  </mat-error>
  <mat-error class="message-canton-error" *ngIf="formGroup.get('canton')?.hasError('NotCantonCara')">
    <span [innerHtml]="'forms.errors.hors-canton' | translate "></span>
  </mat-error>
</div>
